// import { useTheme } from "@emotion/react";
// import { useMediaQuery } from "@mui/material";

import debounce from "lodash.debounce";
import { useCallback, useState } from "react";
import { makeStyles } from "@mui/styles";
// import { Autocomplete, Grid, TextField } from "@mui/material";
import {
	Autocomplete,
	Button,
	ButtonGroup,
	Grid,
	TextField,
	useMediaQuery,
} from "@mui/material";
import { useTheme } from "@emotion/react";
import { renderCodeOption } from "../../utils/functions";

const statusOptions = [
	{
		label: "All Status",
		value: "all",
	},
	{
		label: "In Service",
		value: "in-service",
	},
	{
		label: "Out of service",
		value: "out-service",
	},
	{
		label: "Maintenance",
		value: "maintenance",
	},
	{
		label: "Retired",
		value: "retired",
	},
];

const serviceOptions = [
	{
		label: "All Service",
		value: "all",
	},
	{
		label: "Overdue",
		value: "overdue",
	},
	{
		label: "Due Soon",
		value: "due-soon",
	},
	{
		label: "OK",
		value: "ok",
	},
];

const useStyles = makeStyles((theme) => ({
	sideMenuTitle: {
		fontSize: 20,
		fontWeight: 700,
		color: theme.palette.text.primary,
		marginBottom: "5px",
	},
    colorTitle: {
		color: theme.palette.mode === "dark" ? "#fff !important" : "#000 !important",
	},
}));

const VehiclesTableToolbar = ({
	vehicles,
	search,
	setSearch,
	status,
	setStatus,
	codes,
	serviceFilter,
	setServiceFilter,
	assignmentFilter,
	setAssignmentFilter,
	filters,
	// resetFilters,
	onFilterChange,
	onAddClick,
	employees,
	fundingSources,
}) => {
	const theme = useTheme();
	const btnStyles = {
		color: theme.palette.mode === "dark" ? "#fff" : "primary",
		borderColor: theme.palette.mode === "dark" ? "#fff" : "primary",
		"&:hover": {
			borderColor: theme.palette.mode === "dark" ? "#fff" : "primary",
			backgroundColor: theme.palette.action.hover,
		},
	};
	const isSmall = useMediaQuery(theme.breakpoints.down("md"));
	const classes = useStyles();
	const [advMake, setAdvMake] = useState([]);
	const [advModel, setAdvModel] = useState([]);
	const [advYear, setAdvYear] = useState([]);
	const [advDivision, setAdvDivision] = useState(
		[],
		// initialDivision ? [initialDivision] : [],
	);
	const [advEmployee, setAdvEmployee] = useState([]);
	const [advFunding, setAdvFunding] = useState([]);
	const [advancedActive, setAdvancedActive] = useState(false);
	const [showAdvSearch, setShowAdvSearch] = useState(false);
	const [localFilters, setLocalFilters] = useState(filters);

	const uniq = (arr) => [...new Set(arr.filter(Boolean))].sort();

	// eslint-disable-next-line react-hooks/exhaustive-deps
	const debouncedSearchChange = useCallback(
		debounce((searchString) => {
			setSearch(searchString);
		}, 500),
		[onFilterChange],
	);

	const clearAdvanced = () => {
		setAdvEmployee([]);
		setAdvDivision([]);
		setAdvFunding([]);
	};

	// eslint-disable-next-line react-hooks/exhaustive-deps
	const debouncedFilterChange = useCallback(
		debounce((newFilters) => {
			onFilterChange(newFilters);
		}, 500),
		[onFilterChange],
	);

	const handleFilterChange = useCallback(
		(field, value) => {
			const updatedFilters = { ...localFilters, [field]: value };
			setLocalFilters(updatedFilters);
			debouncedFilterChange(updatedFilters);
		},
		[debouncedFilterChange, localFilters],
	);

	const renderFilterFields = (fields) =>
		fields.map(
			({ type, label, field, options, xs = 2, multiselect = true }) => (
				<Grid item xs={isSmall ? 12 : xs} key={field}>
					{type === "text" ? (
						<TextField
							label={label}
							value={localFilters[field] || ""}
							onChange={(e) =>
								handleFilterChange(field, e.target.value)
							}
							fullWidth
							variant="outlined"
							size="small"
						/>
					) : (
						<Autocomplete
							multiple={multiselect}
							options={options || []}
							value={
								multiselect
									? localFilters[field] || []
									: localFilters[field] || null
							}
							onChange={(_, value) =>
								handleFilterChange(field, value)
							}
							getOptionLabel={(option) => option?.label || ""}
							renderOption={renderCodeOption}
							isOptionEqualToValue={(o, v) =>
								o?.value === v?.value
							}
							renderInput={(params) => (
								<TextField
									{...params}
									label={label}
									variant="outlined"
									size="small"
								/>
							)}
							fullWidth
							sx={
								multiselect
									? {
											"& .MuiAutocomplete-inputRoot": {
												flexWrap: "nowrap",
												maxHeight: "40px",
											},
											"& .MuiAutocomplete-tag": {
												maxWidth: "100%",
												overflow: "hidden",
												textOverflow: "ellipsis",
												whiteSpace: "nowrap",
											},
											"& .MuiAutocomplete-endAdornment": {
												alignSelf: "flex-start",
											},
										}
									: {}
							}
						/>
					)}
				</Grid>
			),
		);

	const filterFields = [
		{
			type: "autocomplete",
			label: "Status",
			field: "status",
			options: statusOptions,
			xs: 1,
		},
		{
			type: "autocomplete",
			label: "Service",
			field: "service",
			options: serviceOptions,
			xs: 1,
		},
	];

	const advanceFilterFields = [
		{
			type: "autocomplete",
			label: "Make",
			field: "make",
			options: [
				{ value: "", label: "— None —" },
				...uniq(vehicles.map((v) => v.make)).map((v) => ({
					value: v,
					label: v,
				})),
			],
			multiselect: true,
			xs: 1.7,
		},
		{
			type: "autocomplete",
			label: "Model",
			field: "model",
			options: [
				{ value: "", label: "— None —" },
				...uniq(vehicles.map((v) => v.model)).map((v) => ({
					value: v,
					label: v,
				})),
			],
			multiselect: true,
			xs: 1.7,
		},
		{
			type: "autocomplete",
			label: "Tags",
			field: "tagTypes",
			options: [
				{ value: "", label: "— None —" },
				...uniq(vehicles.map((v) => String(v.year || ""))).map((v) => ({
					value: v,
					label: v,
				})),
			],
			multiselect: true,
			xs: 1.7,
		},
		{
			type: "autocomplete",
			label: "PAT",
			field: "pat",
			options: [
				{ value: "", label: "— None —" },
				...uniq(vehicles.map((v) => v.division)).map((v) => ({
					value: v,
					label: v,
				})),
			],
			multiselect: true,
			xs: 1.5,
		},
		{
			type: "autocomplete",
			label: "Written",
			field: "written",
			options: [
				{ value: "_none_", label: "— Unassigned —" },
				...employees
					.filter((e) => e.isActive)
					.sort((a, b) => a.lastName.localeCompare(b.lastName))
					.map((e) => ({
						value: String(e.id),
						label: `${e.badge} ${e.lastName}, ${e.firstName}`,
					})),
			],
			multiselect: true,
			xs: 1.5,
		},
		{
			type: "autocomplete",
			label: "Polygraph",
			field: "polygraph",
			options: [
				{ value: "_none_", label: "— No Funding Source —" },
				...(fundingSources || []).map((f) => ({
					value: String(f.id),
					label: f.title,
				})),
			],
			multiselect: true,
			xs: 1.5,
		},
	];

	const buttons = [
		<Button key="all" sx={btnStyles} onClick={() => setAssignmentFilter("All")}>
			All
		</Button>,
		<Button key="out" sx={btnStyles} onClick={() => setAssignmentFilter("out")}>
			↑
		</Button>,
		<Button key="in" sx={btnStyles} onClick={() => setAssignmentFilter("in")}>
			↓
		</Button>,
	];

	return (
		<>
			<div>
				<div className={classes.sideMenuTitle}>Fleet Vehicles</div>
			</div>
			<div className="section-actions mb-2">
				<TextField
					label="Search unit, VIN, make, employee, division, license..."
					type="search"
					className={classes.filter}
					variant="outlined"
					size="small"
					style={{
						width: "100%",
						maxWidth: 250,
					}}
					value={search}
					onChange={(e) => debouncedSearchChange(e.target.value)}
				/>
				{renderFilterFields([...filterFields])}
				<ButtonGroup size="large" aria-label="Large button group">
					{buttons}
				</ButtonGroup>
				<Button
					variant="outlined"
					color="primary"
					sx={btnStyles}
					onClick={() => setShowAdvSearch((s) => !s)}
				>
					🔍 Advanced
					{advancedActive && (
						<span
							style={{
								marginLeft: 4,
								background: "rgba(255,255,255,0.3)",
								borderRadius: 99,
								fontSize: 10,
								fontWeight: 700,
								padding: "1px 5px",
							}}
						>
							ON
						</span>
					)}
				</Button>
				<Button
					variant="outlined"
					color="primary"
					// onClick={() => printVehicleList()}
					title="Print current list"
					sx={btnStyles}
				>
					🖨️ Print
				</Button>
				<Button variant="contained" color="primary" onClick={onAddClick}>
					+ Add Vehicle
				</Button>
			</div>
			{showAdvSearch && (
				<div
					style={{
						margin: "8px",
						padding: "14px 16px",
						background: "var(--surface)",
						border: "1px solid var(--border)",
						borderRadius: "8px",
						display: "flex",
						flexWrap: "wrap",
						gap: 8,
						alignItems: "center",
					}}
				>
					<span
						style={{
							fontSize: 11,
							fontWeight: 700,
							textTransform: "uppercase",
							letterSpacing: "0.06em",
							color: "var(--text2)",
							marginRight: 4,
						}}
					>
						Filter by:
					</span>
					{renderFilterFields([...advanceFilterFields])}
					{advancedActive && (
						<button
							className="btn btn-ghost btn-sm"
							style={{ marginLeft: "auto", fontSize: 11 }}
							onClick={clearAdvanced}
						>
							✕ Clear all filters
						</button>
					)}
				</div>
			)}
		</>
	);
};

export default VehiclesTableToolbar;
